export default {
    baseTitle: 'Rob Phillips'
}